<template>
  <div class="GuestbookMain">
    <guestbook-header
      :secondLang="secondLang"
      :cookieExists="cookieExists"
      :guestPhase="guestPhase || 'anonymous'"
    ></guestbook-header>
    <transition name="slideInOut">
      <guestbook-boxes
        :guestPhase="guestPhase || 'anonymous'"
        :cookieExists="cookieExists"
        :customFonts="guestBookFonts"
        :secondLang="secondLang"
        v-if="lazyLoadBoxes"
      ></guestbook-boxes>
    </transition>
    <guestbook-footer
      v-if="lazyLoadFooter"
      :guestPhase="guestPhase || 'anonymous'"
    ></guestbook-footer>
  </div>
</template>

<script>
import GuestbookHeader from "../components/GuestbookHeader";
const GuestbookBoxes = () => import("../components/GuestbookBoxes");
const GuestbookFooter = () => import("../components/GuestbookFooter");

import cookieMixin from "../mixins/cookieMixin";
import bus from "../bus.js";
import { db } from "../firebase.js";
import { trackBehavior } from "../callables";

export default {
  mixins: [cookieMixin],
  components: {
    GuestbookHeader,
    GuestbookBoxes,
    GuestbookFooter,
  },
  data() {
    return {
      guestPhase: "anonymous",
      secondLang: false,
      guestBookFonts: {},
      cookieExists: null,
      lazyLoadBoxes: false,
      lazyLoadFooter: false,
    };
  },
  async created() {
    var type = this.$route.params.type ? this.$route.params.type : "direct";
    var guestID = this.$route.params.guestid
      ? this.$route.params.guestid
      : "unknownID";

    if (this.$route.params.guestPhase) {
      this.guestPhase = this.$route.params.guestPhase;
    } else if (guestID != "unknownID") {
      try {
        await db
          .ref(`activeguests/${this.$customerId}/${this.$hotelId}/${guestID}`)
          .once("value")
          .then((snapshot) => (this.guestPhase = snapshot.val().type));
      } catch {
        this.guestPhase = "anonymous";
      }
    }

    // secondLang is true if there are more than one language types
    db.ref("customers/" + this.$customerId + "/languageTypes")
      .once("value")
      .then((snapshot) => {
        this.secondLang = snapshot.val().length > 1;
      });

    db.ref(`customers/${this.$customerId}/fonts`)
      .once("value")
      .then((snapshot) => (this.guestBookFonts = snapshot.val()));

    var dgTemp = sessionStorage.getItem("dgTemp");
    if (!dgTemp) {
      trackBehavior({
        action: "open",
        type,
        guestID,
        eventID: this.$hotelId,
        customerID: this.$customerId,
      });
      sessionStorage.setItem("dgTemp", true);
    }

    if (guestID && guestID !== "unknownID") {
      var activeGuestTemp = sessionStorage.getItem("activeGuestTemp");
      if (!activeGuestTemp) {
        sessionStorage.setItem("activeGuestTemp", guestID);
      }
    }
    bus.$on("fetchLazyComponents", () => {
      this.lazyLoadBoxes = true;
      setTimeout(() => (this.lazyLoadFooter = true), 500);
    });
    this.cookieExists = this.getCookie("secondLanguage");
  },
  updated() {
    // Solves the Safari blank page on return wuth back button
    this.$nextTick(() => {
      window.scrollTo(0, 1);
      window.scrollTo(0, 0);
    });
  },
};
</script>
<style scoped>
/* .GuestbookMain {
  padding-top: 70px;
} */
.slideInOut-enter {
  transform: translateY(20px);
  opacity: 0;
}
.slideOutIn-enter-active,
.slideOutIn-leave-active {
  transition: all 0.2s ease;
}
.slideOutIn-enter {
  transform: translateX(-120px);
  opacity: 0;
}
.slideOutIn-leave-to {
  transform: translateX(-120px);
  opacity: 0;
}
</style>
